import { render } from "./JudgeTrainingPanel.vue?vue&type=template&id=b070885c&scoped=true"
import script from "./JudgeTrainingPanel.vue?vue&type=script&lang=js"
export * from "./JudgeTrainingPanel.vue?vue&type=script&lang=js"

import "./JudgeTrainingPanel.vue?vue&type=style&index=0&id=b070885c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b070885c"]])

export default __exports__